import { useQuery } from "@tanstack/react-query";
import { hasCustomerId } from "@/lib/api";
import { fetchPurchasedProducts } from "@/lib/api";

export interface PurchasedProduct {
  id: number;
  variant_id: number | null;
  title: string;
  image_url: string | null;
  favorite_id: number | null;
  is_favorite: boolean;
  last_bought_at?: string;
  price?: string | number;
  url?: string;
}

export function usePurchasedProducts() {
  return useQuery({
    queryKey: ["purchased-products"],
    queryFn: async (): Promise<PurchasedProduct[]> => {
      const raw = await fetchPurchasedProducts();
      return (raw ?? []) as PurchasedProduct[];
    },
    enabled: hasCustomerId(),
    staleTime: 1000 * 60 * 2,
  });
}
